import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=513158b4&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"
import style0 from "./Gallery.vue?vue&type=style&index=0&id=513158b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513158b4",
  null
  
)

export default component.exports